import SyntaxHighlighter from 'react-syntax-highlighter/dist/esm/prism-light';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import oneDark from "react-syntax-highlighter/dist/esm/styles/prism/one-dark";
import { copyText } from '../../../context/helper';
import { Button } from 'antd';
import { useEffect, useState } from 'react';


const copyBtnStyle = {
    position: "absolute",
    top: "10px",
    right: "10px",
    background: "rgb(47, 47, 47)",
    color: "white",
};

export default function GenerateMessage(props) {
    const { content, i } = props;
    const [copy, setCopy] = useState("Copy");

    const copyFunc = (text) => {
        copyText(text);
        setCopy("Copied!");
        setTimeout(() => {
            setCopy("Copy");
        }, 2000);
    }

    return (<ReactMarkdown
        children={content}
        key={i}
        remarkPlugins={[remarkGfm]}
        components={{
            table({ children, ...props }) {
                return (
                    <div style={{ overflowX: 'auto', marginBottom: '16px' }}>
                        <table style={{ 
                            borderCollapse: 'collapse', 
                            width: '100%', 
                            fontSize: '13px',
                            border: '1px solid #e0e0e0'
                        }} {...props}>
                            {children}
                        </table>
                    </div>
                );
            },
            thead({ children, ...props }) {
                return (
                    <thead style={{ backgroundColor: '#f5f5f5' }} {...props}>
                        {children}
                    </thead>
                );
            },
            th({ children, ...props }) {
                return (
                    <th style={{ 
                        padding: '10px', 
                        textAlign: 'left', 
                        borderBottom: '2px solid #d0d0d0',
                        fontWeight: '600',
                        whiteSpace: 'nowrap'
                    }} {...props}>
                        {children}
                    </th>
                );
            },
            td({ children, ...props }) {
                return (
                    <td style={{ 
                        padding: '8px 10px', 
                        borderBottom: '1px solid #e0e0e0'
                    }} {...props}>
                        {children}
                    </td>
                );
            },
            code({ node, inline, className, children, ...props }) {
                const match = /language-(\w+)/.exec(className || '');
                return !inline && match ? (
                    <div style={{ position: "relative" }}>
                        <Button style={copyBtnStyle} onClick={() => copyFunc(children)}>{copy}</Button>
                        {/* <div style={{ 
        backgroundColor: "rgb(40, 44, 52)", 
        color: "#fff", 
        padding: "4px 8px 0 8px", 
        fontSize: "12px", 
        fontFamily: "monospace",
        borderTopLeftRadius: "6px",
        borderTopRightRadius: "6px"
      }}>
        {match[1]?.toUpperCase()}
      </div> */}
                        <SyntaxHighlighter style={oneDark} language={match[1]} PreTag="div" {...props} customStyle={{ marginBottom: 0 }}>
                            {String(children).replace(/\n$/, '')}
                        </SyntaxHighlighter>
                    </div>
                ) : (
                    <code className={className} {...props}>
                        {children}
                    </code>
                );
            }
        }}
    />);
}